import React, { useState } from "react";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";

const ActiveUserInfo = ({
  stageScreen,
  setStageScreen,
  setStep,
  isLoading,
  setIsLoading,
  activeUserDetail,
}) => {
  const [showTypes, setShowTypes] = useState(false);
  const onSubmit = (value) => {
    if (!activeUserDetail) {
      return toast.error(
        "User details not found or Your KYC is incomplete. Thank You!"
      );
    }
    if (
      activeUserDetail?.bank_details?.length === 0 &&
      value.modification_type === "Modification"
    ) {
      return toast.error("Error: At least one primary bank is required.");
    }
    localStorage.setItem("BankRequestType", value.modification_type);
    setStep("CheckPrevRequest");
  };
  // const getBankDetails = (bank = []) => {
  //   let res =
  //     (bank.length > 0 && bank.filter((item) => item.verified_bank_account === 1)[0]) ||
  //     null;
  //   let html = null;
  //   if (res) {
  //     html = (
  //       <>
  //         <div className="row my-1">
  //           <div className="col-sm">Name</div>
  //           <div className="col-sm">{res.registered_name}</div>
  //         </div>
  //         <div className="row my-1">
  //           <div className="col-sm">Account Type</div>
  //           <div className="col-sm">{res.account_type}</div>
  //         </div>
  //         <div className="row my-1">
  //           <div className="col-sm">Account Number</div>
  //           <div className="col-sm">{res.verified_account_number}</div>
  //         </div>
  //         <div className="row my-1">
  //           <div className="col-sm">Bank Name</div>
  //           <div className="col-sm">{res.verified_bank_name}</div>
  //         </div>
  //         <div className="row my-1">
  //           <div className="col-sm">Branch</div>
  //           <div className="col-sm">{res.verified_branch}</div>
  //         </div>
  //         <div className="row my-1">
  //           <div className="col-sm">IFSC Code</div>
  //           <div className="col-sm">{res.verified_ifsc}</div>
  //         </div>
  //         {res.verified_micr_code && (
  //           <div className="row my-1">
  //             <div className="col-sm">MICR Code</div>
  //             <div className="col-sm">{res.verified_micr_code}</div>
  //           </div>
  //         )}
  //       </>
  //     );
  //   }
  //   return html;
  // };
  return (
    <div>
      <Title title="Bank Details" />
      <div className="col-md-12 mt-3">
        <div className="ml-2">
          {activeUserDetail && (
            <div>
              <div className="row mt-1">
                <div className="row">
                  <h6 className="col-sm">Full Name</h6>
                  <div className="col-sm">{activeUserDetail.full_name}</div>
                </div>
              </div>
              <div className="row mt-1">
                <div className="row">
                  <h6 className="col-sm">Mobile Number</h6>
                  <div className="col-sm">
                    {activeUserDetail.phone?.slice(2)}
                  </div>
                </div>
              </div>
              <div className="row mt-1">
                <div className="row">
                  <h6 className="col-sm">Email Address</h6>
                  <div className="col-sm">{activeUserDetail.email}</div>
                </div>
              </div>
              <div className="row mt-1">
                <div className="row">
                  <h6 className="col-sm">PAN Number</h6>
                  <div className="col-sm">
                    {activeUserDetail.poi?.[0]?.pan_number}
                  </div>
                </div>
              </div>
              {activeUserDetail?.bank_details?.length > 0 && (
                <div className="row mt-1">
                  <div className="row">
                    <h6 className="col-sm">Bank Details:</h6>
                  </div>
                  <table className="table mx-2">
                    <thead>
                      <tr>
                        {/* <th scope="col">Name</th> */}
                        <th scope="col">Account Type</th>
                        <th scope="col">Account Number</th>
                        <th scope="col">Bank Name</th>
                        <th scope="col">Branch</th>
                        <th scope="col">IFSC Code</th>
                        {/* <th scope="col">MICR Code</th> */}
                        <th scope="col">Primary Bank</th>
                      </tr>
                    </thead>
                    <tbody>
                      {activeUserDetail.bank_details
                        .filter((item) => item.verified_bank_account === 1)
                        .map((item) => {
                          return (
                            <tr key={item.idx}>
                              {/* <td>{item.registered_name}</td> */}
                              <td>{item.account_type}</td>
                              <td>{item.verified_account_number}</td>
                              <td>{item.verified_bank_name}</td>
                              <td>{item.verified_branch}</td>
                              <td>{item.verified_ifsc}</td>
                              {/* <td>{item.verified_micr_code || "-"}</td> */}
                              <td>
                                {item.is_primary_bank_account === 1
                                  ? "Yes"
                                  : "No"}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              )}
              {/* {activeUserDetail?.bank_details?.length > 0 && (
                <div className="row mt-4">
                  <h5 className="text-bold m-0">Bank Details</h5>
                  {getBankDetails(activeUserDetail.bank_details)}
                </div>
              )} */}
            </div>
          )}
          <div className="d-flex mt-4">
            <div className="ml-2">
              <Button
                title="Back"
                type="button"
                handleClick={() => setStep("ValidatePan")}
                loading={isLoading}
              />
            </div>
            <div className="mx-2">
              <Button
                title="Next"
                handleClick={() => setShowTypes((show) => !show)}
                loading={isLoading}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="md"
        backdrop="static"
        keyboard={false}
        show={showTypes}
        onHide={setShowTypes}
      >
        <Modal.Header>
          <Modal.Title>Bank Modification Types</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-md-12">
            <Formik
              enableReinitialize={true}
              initialValues={{ modification_type: "" }}
              validate={(values) => {
                const errors = {};
                if (!values.modification_type) {
                  errors.modification_type = "Modification type is required";
                }
                return errors;
              }}
              onSubmit={onSubmit}
            >
              {({ isValid, dirty, isSubmitting, setFieldValue }) => (
                <Form>
                  <div className="row">
                    <div className="col-sm form-group">
                      <label className="mb-2">Please select an option</label>
                      {[
                        {
                          name: "Add New Bank",
                          value: "Add New Account",
                        },
                        {
                          name: "Modify Existing Bank Details",
                          value: "Modification",
                        },
                      ].map((item) => {
                        return (
                          <div
                            className="form-check my-1"
                            key={item.name}
                          >
                            <Field
                              name="modification_type"
                              className="form-check-input"
                              type="radio"
                              value={item.value}
                            />
                            <label className="form-check-label">
                              {item.name}
                            </label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="d-flex justify-content-end form-group my-4">
                    <div className="mx-2">
                      <Button
                        type="button"
                        title="Close"
                        handleClick={() => setShowTypes((show) => !show)}
                      />
                    </div>
                    <div className="mx-2">
                      <Button
                        title="Submit"
                        disabled={!isValid || !dirty || isSubmitting}
                      />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ActiveUserInfo;
